export const enum EVENT_CLICK_TYPE {
  BUTTON = 'button',
  LINK = 'link'
}

export const enum USER_LOGGED_IN_STATUS {
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  LOGIN_SUCCESS = 'successful login',
  LOGIN_FAILURE = 'login failure',
  LOGIN_IN_FAILURE = 'log-in-failure',
  LOGIN_FAILED = 'LOGIN_FAILED',
  LOGIN_AUTHENTICATION_FAILED = 'Login authentication failed',
  HOT = 'hot',
  WARM = 'warm',
  COLD = 'cold'
}
export const enum ACCOUNT_RECOVERY_PAGES {
  GLOBAL_HEADER = 'global header login modal'
}
export const HEADER = 'header';
export const HEADER_MENU = {
  BOOK: {
    NAME: 'book',
    PAGE_SECTION: 'header:book',
    FLIGHT_SEARCH: {
      NAME: 'flights:search',
      PAGE_SECTION: 'header:book:flights'
    },
    STAYS_SEARCH: {
      NAME: 'stays:search',
      PAGE_SECTION: 'header:book:stays'
    },
    CARS_SEARCH: {
      NAME: 'cars:search',
      PAGE_SECTION: 'header:book:cars'
    },
    VACATIONS_SEARCH: {
      NAME: 'vacations:search',
      PAGE_SECTION: 'header:book:vacations'
    },
    CRUISES: {
      NAME: 'cruises',
      PAGE_SECTION: 'header:book:cruises'
    }
  },
  CHECK_IN: {
    NAME: 'check in',
    PAGE_SECTION: 'header:check in'
  },
  MY_TRIPS: {
    NAME: 'my trips',
    PAGE_SECTION: 'header:my trips',
    DELTA_STAYS: {
      NAME: 'my trips:delta stays',
      PAGE_SECTION: 'header:my trips:delta stays'
    },
    DELTA_CAR_RENTALS: {
      NAME: 'my trips:delta car rentals',
      PAGE_SECTION: 'header:my trips:delta car rentals'
    }
  },
  FLIGHT_STATUS: {
    NAME: 'flight status',
    PAGE_SECTION: 'header:flight status'
  },
  GLOBAL_SEARCH: {
    NAME: 'search icon click',
    PAGE_SECTION: 'header:global nav',
    SEARCH_SUBMIT: {
      NAME: 'search:submit',
      PAGE_SECTION: 'header:global nav:search submit'
    },
    SEARCH_RESULTS: {
      NAME: 'search:results',
      PAGE_SECTION: 'header:global nav:search results'
    },
    SEARCH_NO_RESULTS: {
      NAME: 'search:no results',
      PAGE_SECTION: 'header:global nav:search no results'
    },
    SEARCH_CLOSE: {
      NAME: 'search:close',
      PAGE_SECTION: 'header:global nav:search close'
    }
  },
  HOMEPAGE: {
    NAME: 'homepage',
    PAGE_SECTION: 'homepage:'
  },
  TRAVEL_INFO: {
    NAME: 'travel info',
    PAGE_SECTION: 'header:travel info'
  },
  SKYMILES: {
    NAME: 'skymiles',
    PAGE_SECTION: 'header:skymiles'
  },
  NEED_HELP: {
    NAME: 'need help',
    PAGE_SECTION: 'header:need help'
  },
  LOGIN: {
    NAME: 'login',
    PAGE_SECTION: 'header:login'
  },
  SIGNUP: {
    NAME: 'signup',
    PAGE_SECTION: 'header:signup'
  },
  NOTIFICATION: {
    NAME: 'notification',
    PAGE_SECTION: 'header:notification'
  },
  SEARCH: {
    NAME: 'search',
    PAGE_SECTION: 'header:search'
  },
  HOME: {
    NAME: 'home',
    PAGE_SECTION: 'header:home'
  },
  SKYTEAM: {
    NAME: 'skyteam',
    PAGE_SECTION: 'header:skyteam'
  }
};

export const enum HEADER_TOP_MENU {
  BOOK = 'BOOK',
  CHECK_IN = 'CHECK_IN',
  MY_TRIPS = 'MY_TRIPS',
  FLIGHT_STATUS = 'FLIGHT_STATUS',
  GLOBAL_SEARCH = 'GLOBAL_SEARCH',
  TRAVEL_INFO = 'TRAVEL_INFO',
  SKYMILES = 'SKYMILES',
  NEED_HELP = 'NEED_HELP',
  NOTIFICATION = 'NOTIFICATION',
  SEARCH = 'SEARCH',
  HOME = 'HOME',
  SKYTEAM = 'SKYTEAM'
}

export const enum HEADER_MENU_BOOK {
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  STAYS_SEARCH = 'STAYS_SEARCH',
  CARS_SEARCH = 'CARS_SEARCH',
  VACATIONS_SEARCH = 'VACATIONS_SEARCH',
  CRUISES = 'CRUISES'
}
